export enum TabScreens {
  Home = 'Home',
  Menu = 'Menu',
  FeeDetails = 'Fee Details',
  Order = 'Order',
  Favorite = 'Favorite',
  Notification = 'Notifications',
  Academy = 'Academy',
  History = 'History',
  Admin = 'Admin',
}

export enum Routes {
  Onboarding = '/',
  SignIn = '/sign-in',
  OrderHistory = '/profile/orders',
  OrderHistoryEmpty = '/profile/orders-empty',
  EditProfile = '/profile/edit',
  VerifyYourEmail = '/verify-your-email',
  MyPromocodes = '/profile/promocodes',
  NewPassword = '/new-password',
  Filter = '/filter',
  SignUp = '/sign-up',
  SignUpAccountCreated = '/sign-up-account-created',
  ForgotPassword = '/forgot-password',
  OrderSuccessful = '/order-successful',
  Checkout = '/checkout',
  ForgotPasswordSentEmail = '/forgot-password-sent-email',
  Shop = '/shop',
  PromocodesEmpty = '/promocodes-empty',
  Reviews = '/reviews',
  Description = '/description',
  LeaveAReviews = '/leave-a-reviews',
  Product = '/product/:id',
  MyPromocodesEmpty = '/profile/promocodes-empty',
  TabNavigator = '/tab-navigator',
  Verification = '/verification',
  ConfirmationCode = '/confirmation-code',
  SendEmailOtp = '/send-email-otp',
  VerifyEmail = '/verify-email',
  SendPhoneOtp = '/send-phone-otp',
  VerifyPhone = '/verify-phone',
  EmailVerified = '/email-verified',
  PhoneVerified = '/phone-verified',
  MenuList = '/menu-list',
  Search = '/search',
  Wallet = '/wallet',
  Promocodes = '/promocodes',
  ShippingAPaymentInfo = '/shipping-a-payment-info',
  OrderFailed = '/order-failed',
  TrackYourOrder = '/track-your-order',
  LeaveAReview = '/leave-a-review',
  FAQ = '/faq',
  Dish = '/dish/:id',
  MyAddress = '/my-address',
  CheckoutPaymentMethod = '/checkout-payment-method',
  CheckoutShippingDetails = '/checkout-shipping-details',
  PaymentMethod = '/payment-method',
  AddANewAddress = '/add-a-new-address',
  AddANewCard = '/add-a-new-card',
  VerifyYourPhoneNumber = '/verify-your-phone-number',

  Activities = '/activities',
  MySons = '/my-sons',
  ExtraCurricular = '/extra-curricular',
  Articles = '/articles',
  Creation = '/creation',
  Partners = '/partners',
  Account = '/account',
  Chat = '/chat',
  Academy = '/academy',
  ClockInSuccess = '/clock-in-success',
  GradeAnalysis = '/grade-analysis',
  DetailActivities = '/detail-activities/:id',
  DetailArticles = '/detail-articles/:id',
  DetailExtraCurriculars = '/detail-extra-curricular/:id',
  DetailPartners = '/detail-partners/:id',
  DetailSons = '/detail-sons/:id',
  DetailSonsSubjects = '/detail-sons/detail-sons-subjects/:id',
  DetailSonsRaport = '/detail-sons/detail-sons-raport/:id',
  DetailSonsRkh = '/detail-sons/detail-sons-rkh/:id',
  DetailSonsAbsensi = '/detail-sons/detail-sons-absensi/:id',
  DetailSonsGradeAnalysis = '/detail-sons/detail-sons-grade-analysis/:id',
  DetailCreation = '/detail-creation/:id',
  DetailAcademy = '/detail-academy/:id',

  AdminDashboard = '/Admin-Dashboard',
  PatrolFormTable = '/Kelola-jadwal-patroli',
  PatrolDetailPage = '/Patrol-Detail-Page',
  AddSpotPage = '/add-spot-page',
  // EditSpotPage = '/edit-spot-page',
  PatrolUser = '/patrol-user',
  PatrolUserForm = '/patrol-user/form',
  // PatrolUserDetail = '/patrol-user/detail',
  CreateGroup = '/create-group-patrol',
  AssignUsersToGroup = '/assign-users-to-group/:groupId',
  GroupSpace = '/group-space',
  LaporanRute = '/laporan-rute',
  KelolaPatrol = '/kelola-patrol',
  Unauthorize = '/unauthorize',
}
